import { create } from 'zustand';

interface UiState {
  sidebarOpen: boolean;
  isMobile: boolean;
  isLoading: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setIsMobile: (isMobile: boolean) => void;
  setLoading: (loading: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: false,
  isMobile: false,
  isLoading: false,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setIsMobile: (isMobile) => set({ isMobile }),
  setLoading: (loading) => set({ isLoading: loading }),
}));
